import { render, staticRenderFns } from "./SettingsNotification.vue?vue&type=template&id=058bb1e8&"
import script from "./SettingsNotification.vue?vue&type=script&lang=ts&"
export * from "./SettingsNotification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports